// main.js
import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import router from './router'
import 'element-ui/lib/theme-chalk/index.css'
import Login from './components/LoginPage.vue'
import store from './store' // 确保路径正确
import * as echarts from 'echarts'
import VueClipboard from 'vue-clipboard2'

Vue.prototype.$echarts = echarts
Vue.use(ElementUI)
Vue.use(VueClipboard)
Vue.config.productionTip = false

// 检查认证状态的函数
const checkAuth = () => {
	// console.log("地址", window.location)
	if (window.location.hash.includes('/share-page')) {

		return true;
	}
	try {
		const authData = JSON.parse(localStorage.getItem('token'))
		const expires = JSON.parse(localStorage.getItem('expires'))
		if (!authData) return false

		const currentTime = Math.floor(Date.now() / 1000)
		return currentTime <= expires
	} catch (e) {
		return false
	}
}

new Vue({
	router,
	store, // 确保这里注入了store
	created() {
		// 确保store存在再访问
		if (this.$store) {
			const isAuthenticated = checkAuth()
			// console.log("检查", isAuthenticated)
			this.$store.commit('setLoggedIn', isAuthenticated)

			// 如果已认证但当前路径是登录页，则跳转到首页
			if (isAuthenticated && this.$route.path === '/') {
				this.$router.push('/')
			}
		}

		// 定时检查token
		this.tokenCheckInterval = setInterval(() => {
			if (this.$store) {
				const isAuth = checkAuth()
				this.$store.commit('setLoggedIn', isAuth)
				if (!isAuth && this.$route.path !== '/') {
					this.$router.push('/')
				}
			}
		}, 3600000)
	},
	beforeDestroy() {
		clearInterval(this.tokenCheckInterval)
	},
	render(h) {
		// 确保store存在再访问
		if (this.$store) {
			return this.$store.state.isLoggedIn ? h(App) : h(Login)
		}
		return h(Login) // 如果store不存在，默认显示登录页
	}
}).$mount('#app')